module.exports = __webpack_public_path__ + "static/wedding_4-ddf95ef6e13ecd8e9489f6a5faafca01.jpg";